import { t as Swiper } from "./swiper-bundle.esm.js";
//#region frontend/scripts/ResponsiveSwiper.js
var ResponsiveSwiper = class {
	constructor(container, mediaQuery, options) {
		this.container = container;
		this.query = window.matchMedia(mediaQuery);
		this.options = options;
		this.swiper = null;
		this.onBreakpointChange = this.checkBreakpoint.bind(this);
		if (this.container) {
			this.query.addEventListener("change", this.onBreakpointChange);
			this.checkBreakpoint(this.query);
		}
	}
	checkBreakpoint(e) {
		if (e.matches) this.initSwiper();
		else if (this.swiper) {
			this.swiper.destroy(false, true);
			this.swiper = null;
		}
	}
	initSwiper() {
		if (!this.swiper) this.swiper = new Swiper(this.container, this.options);
	}
};
//#endregion
export { ResponsiveSwiper as t };
